<div class="container">
  <mat-card>
    <form [formGroup]="taxComponentForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (taxComponentForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Percentage' | translate }}</mat-label>
            <input type="number" matInput required formControlName="percentage" />
            @if (taxComponentForm.controls.percentage.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Percentage' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
            @if (
              taxComponentForm.controls.percentage.hasError('pattern') ||
              taxComponentForm.controls.percentage.hasError('max')
            ) {
              <mat-error>
                {{ 'labels.inputs.Percentage' | translate }} <strong>{{ 'labels.commons.should' | translate }}</strong>
                {{ 'labels.commons.be larger than 0 and at most 100' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Debit Account Type' | translate }}</mat-label>
            <mat-select formControlName="debitAccountType">
              @for (debitAccountType of debitAccountTypeData; track debitAccountType) {
                <mat-option [value]="debitAccountType.id">
                  {{ debitAccountType.value | translateKey: 'inputs.accounting' }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (debitAccountData.length > 0) {
            <LOSx-gl-account-selector
              [inputFormControl]="taxComponentForm.controls.debitAccountId"
              [glAccountList]="debitAccountData"
              [required]="false"
              [inputLabel]="'Debit Account'"
            >
            </LOSx-gl-account-selector>
          }

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Credit Account Type' | translate }}</mat-label>
            <mat-select formControlName="creditAccountType">
              @for (creditAccountType of creditAccountTypeData; track creditAccountType) {
                <mat-option [value]="creditAccountType.id">
                  {{ creditAccountType.value | translateKey: 'inputs.accounting' }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (creditAccountData.length > 0) {
            <LOSx-gl-account-selector
              [inputFormControl]="taxComponentForm.controls.creditAccountId"
              [glAccountList]="creditAccountData"
              [required]="false"
              [inputLabel]="'Credit Account'"
            >
            </LOSx-gl-account-selector>
          }

          <mat-form-field (click)="startDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Start Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="startDatePicker"
              required
              formControlName="startDate"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            @if (taxComponentForm.controls.startDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Start Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!taxComponentForm.valid"
          *LOSxHasPermission="'CREATE_TAXCOMPONENT'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
